module.exports = "/_next/static/images/f85f227a575f0cf4f592b166add5c71b-nubanker-eng@0.5x.jpg.webp";